import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { FlareFileReviewerComponent } from './flare-file-reviewer.component';

@NgModule({
  declarations: [FlareFileReviewerComponent],
  imports: [
    CommonModule,
    FlareTextEditorModule,
    MatSnackBarModule
  ],
  exports: [FlareFileReviewerComponent]
})
export class FlareFileReviewerModule { }
